import i18n from 'i18next';

export class JsonError extends Error {
    constructor() {
        super(i18n.t('errors.json'));
    }
}
